import axios, { AxiosRequestConfig } from 'axios';
import { appConfig } from '../config/appConfig';

const axiosConfig: AxiosRequestConfig = {
  baseURL: appConfig.apiBaseUrl,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
    'X-Requested-With': 'XMLHttpRequest',
    'Access-Control-Allow-Origin': 'http://localhost:8100',
    'Access-Control-Allow-Methods': 'GET, POST, PUT, DELETE, OPTIONS',
    'Access-Control-Allow-Headers': 'Content-Type, Authorization, X-Requested-With',
    'Access-Control-Max-Age': '86400',
  },
  withCredentials: false,
};

const axiosInstance = axios.create(axiosConfig);

// Add request interceptor to add the auth token and handle CORS
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('jwtToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    // Ensure CORS headers are set for each request
    config.headers['Access-Control-Allow-Origin'] = 'http://localhost:8100';
    config.headers['Access-Control-Allow-Methods'] = 'GET, POST, PUT, DELETE, OPTIONS';
    config.headers['Access-Control-Allow-Headers'] = 'Content-Type, Authorization, X-Requested-With';

    // Optional: Add debug logging
    console.log('Request Config:', {
      url: config.url,
      method: config.method,
      headers: config.headers,
      data: config.data,
    });

    return config;
  },
  (error) => {
    console.error('Request Error:', error);
    return Promise.reject(error);
  }
);

// Add response interceptor to handle 401 errors and log responses
axiosInstance.interceptors.response.use(
  (response) => {
    // Optional: Add debug logging
    console.log('Response:', {
      status: response.status,
      headers: response.headers,
      data: response.data,
    });
    return response;
  },
  (error) => {
    if (error.response?.status === 401) {
      // Clear local storage and redirect to login
      localStorage.removeItem('jwtToken');
      localStorage.removeItem('jwtTokenExpiry');
      localStorage.removeItem('userInfo');
      // Get base path from current URL or default to empty for localhost
      const base = window.location.pathname.includes('/panel') ? '/panel' : '';
      window.location.href = `${base}/login`;
    }
    console.error('Response Error:', error);
    return Promise.reject(error);
  }
);

export default axiosInstance;
